/**
 * @file PickingTaskDocHeader.tsx
 * @description Шапка задания на сборку по эталону складского документа
 * (phase19.23; phase19.31 зона «Склад», минимум по SC50 — в верхней панели).
 *
 * «Назад» (к очереди или журналу), номер задания, статус по реестру,
 * пояснение «Заказ · склад · получение», «⋯» и одно главное действие
 * (`usePickingTaskHeaderActions`); на телефоне главное действие — в общей
 * нижней полосе каркаса. Плитки «кто / когда / собрано» — в содержимом.
 */

import { usePickingTaskHeaderActions, type PickingTaskActionProps } from "./PickingTaskHeaderActions";
import { PickingStatusBadge } from "./PickingStatusBadge";
import { buildPickingTaskMeta } from "./PickingTaskMeta";
import { WmsDocumentPageHeader } from "../WmsDocumentPageHeader";
import { formatDeliveryMethod } from "../../../lib/api-picking";

interface Props extends PickingTaskActionProps {
  /** Слаг магазина — ссылка на заказ в плитке. */
  slug: string | undefined;
  /** Право SHOP_VIEW_ORDERS: без него номер заказа не ссылка. */
  canOpenOrder: boolean;
  /** «Назад»: адрес и подпись (очередь или журнал — откуда пришли). */
  back: { to: string; label: string };
}

export function PickingTaskDocHeader({ slug, canOpenOrder, back, ...actions }: Props) {
  const { task, currentUserId } = actions;
  const parts = usePickingTaskHeaderActions(actions);
  return (
    <WmsDocumentPageHeader
      number={task.number}
      status={<PickingStatusBadge status={task.status} />}
      subtitle={`Заказ ${task.orderNumber} · ${task.warehouse.name} · ${formatDeliveryMethod(task.deliveryMethod)}`}
      back={back}
      meta={buildPickingTaskMeta({ task, currentUserId, slug, canOpenOrder })}
      action={parts.action}
      menu={parts.menu}
      menuLabel="Действия с заданием"
      hint={parts.hint}
      dialogs={parts.dialogs}
    />
  );
}
